import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { Text } from "@/components/ui/baseUi/text"

export function BoxProgramTemplateHeaderLeftView({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div className={cn("mb-5 flex h-50 flex-col gap-2 rounded-4xl bg-surface-foreground p-4", className)} {...props}>
      <Text fontStyle="TM">{word("box.programmation.activity.typicalWeek")}</Text>
      <Text fontStyle="BS">{word("box.programmation.typicalWeek.subTitle")}</Text>
    </div>
  )
}
